import { Component, Input } from '@angular/core';

@Component({
  selector: 'opac-card-item-detail',
  templateUrl: './card-item-detail.component.html',
  styleUrls: ['./card-item-detail.component.scss']
})
export class CardItemDetailComponent {
  @Input() label!: string;
}
